//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    addToCategoryResultCode()
    rebuildTopCategoryResult()

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultCategoryItems = []
  var arrayResultTextItems = []
  var arrayResultSubTextItems = []
  var arrayResultLinkItems = []
  var arrayResultSideCategory = []
  var mainItem = false
  var anotherItemText = true
  var anotherItemSubtext = true
  var anotherItemLink = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    item.find('.js-json-input').each(function () {
      input = $(this)
      var dataJson = input.attr('data-json')
      var dataVar = input.attr('data-var')
      if (input.val().length > 0) {
        var inputValue = input.val()
        if (dataVar === 'bannerKLIKAddonTitleLang') {
          arrayResultTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'bannerKLIKAddonTextLang') {
          arrayResultSubTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'bannerKLIKAddonLinkHrefLang') {
          arrayResultLinkItems.push(`${dataJson}:"/${inputValue}"`)
        }
      }
    })

    if (anotherItemText) {
      if (arrayResultTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">bannerKLIKAddonTitleLang</span> = <span class="js-result-value txt-green">{${arrayResultTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemText = false
      }
    }

    if (anotherItemSubtext) {
      if (arrayResultSubTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">bannerKLIKAddonTextLang</span> = <span class="js-result-value txt-green">{${arrayResultSubTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemSubtext = false
      }
    }

    if (anotherItemLink) {
      if (arrayResultLinkItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">bannerKLIKAddonLinkHrefLang</span> = <span class="js-result-value txt-green">{${arrayResultLinkItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemLink = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputDivider = inputParent.data('divider')
      var inputType = inputParent.data('type')

      if (inputDivider == true) {
        inputValue = '/' + inputValue
      }

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (input.hasClass('js-json-input')) {
      } else {
        if (blockItemCSS) {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategoryCSS.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
        } else {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategory.push(templateBoxItem)
          arrayResultSideCategory.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
        }
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      if (element.attr('data-type') === 'option') {
        checkboxValue = `"${element.find('select').val()}"`
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var bannerCTASidebar
var bannerCTATemplate
var bannerCTARadius = ''
var bannerCTABG = ''
var bannerCTABGOverlay = ''
var bannerCTABGOverlaySet = ''
var bannerCTABGSide = ''
var bannerCTABorder = ''
var bannerCTARow = ''
var bannerCTAIcon = ''

var bannerCTAAddonTitle = ''
var bannerCTAAddonText = ''
var bannerCTAAddonLink = ''

var bannerTitle = ''
var bannerText = ''
var bannerLink = ''

function rebuildTopCategoryResult() {
  buttonsBlock = $('.result-block')

  bannerCTAAddon = $('#banner_cta_active').is(':checked')
  bannerCTAAddonRadius = $('#banner_cta_radius').is(':checked')

  bannerCTATitle = $('#banner_cta_title').val()
  bannerCTAText = $('#banner_cta_text').val()
  bannerCTALink = $('#banner_cta_link').is(':checked')
  bannerCTALinkHref = $('#banner_cta_link_url').val()
  bannerCTALinkHrefExternal = $('#banner_cta_link_url_external').is(':checked')

  bannerCTAAddonIcon = $('#banner_cta_icon_set').is(':checked')
  bannerCTAAddonIconImage = $('#banner_cta_icon_image').val()

  bannerCTAAddonBG = $('#banner_cta_bg').is(':checked')
  bannerCTAAddonBGOverlay = $('#banner_cta_bg_overlay').is(':checked')
  bannerCTAAddonBGSide = $('#banner_cta_bg_side').is(':checked')
  bannerCTAAddonBGImage = $('#banner_cta_bg_image').val()
  bannerCTAAddonBorder = $('#banner_cta_border').is(':checked')

  // CSS
  let root = document.documentElement

  root.style.setProperty(
    '--banner-cta-border-radius',
    $('#banner_cta_border_radius').val(),
  )

  root.style.setProperty('--banner-cta-BG', $('#banner_cta_bgs').val())

  root.style.setProperty(
    '--banner-cta-BG-hover',
    $('#banner_cta_bg-hover').val(),
  )

  root.style.setProperty(
    '--banner-cta-title-color',
    $('#banner_cta_title_color').val(),
  )

  root.style.setProperty(
    '--banner-cta-text-color',
    $('#banner_cta_text_color').val(),
  )

  root.style.setProperty(
    '--banner-cta-icon-color',
    $('#banner_cta_icon_color').val(),
  )

  root.style.setProperty(
    '--banner-cta-border-color',
    $('#banner_cta_border_color').val(),
  )

  if (bannerCTAAddon) {
    $('body').addClass('banner-cta-addon')
    removeButton()
    setBannerCTAText()
    setBannerCTAIcon()
    setBannerCTADesign()
    createBannerCTA()

    setBannerCTALink()
  } else {
    $('body').removeClass('banner-cta-addon')
    removeButton()
  }
}

function createBannerCTA() {
  bannerCTATemplate = `
		<div class="banner-cta js-banner-cta ${bannerCTABorder} ${bannerCTABGOverlaySet} ${bannerCTARadius} ${bannerCTABG} ${bannerCTABGSide}" ${bannerCTABGOverlay}>
			${bannerCTAIcon}
			<div class="banner-cta__text-block">
				${bannerText}
				<div class="banner-cta__title">${bannerTitle}</div>
			</div>
		</div>
	`

  $('.result-block').append($(bannerCTATemplate))
}

function setBannerCTALink() {
  if (bannerCTALink) {
    if (bannerCTALinkHrefExternal == true) {
      $('.js-banner-cta').wrap(
        '<div class="banner-cta-box"><a class="banner-cta-link" href="' +
          bannerCTALinkHref +
          '" target="_blank"></a></div>',
      )
    } else {
      $('.js-banner-cta').wrap(
        '<div class="banner-cta-box"><a class="banner-cta-link" href="' +
          bannerCTALinkHref +
          '"></a></div>',
      )
    }
  }
}

// Set icon for button in detail
function setBannerCTAIcon() {
  if (
    bannerCTAAddonIconImage.length != 0 ||
    bannerCTAAddonBGImage.length != 0
  ) {
    var imgSrc
    if (bannerCTAAddonBGImage.length != 0) {
      imgSrc = bannerCTAAddonBGImage
    }
    if (bannerCTAAddonIconImage.length != 0) {
      imgSrc = bannerCTAAddonIconImage
    }
    bannerCTAIcon = `<div class="banner-cta__icon has-img"><img src="${imgSrc}" class="btn-cart-img"></div>`
  }

  if (bannerCTAAddonIcon) {
    if (
      bannerCTAAddonIconImage.length == 0 &&
      bannerCTAAddonBGImage.length == 0
    ) {
      var svgSale = `
				<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 100 100" width="100" height="100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
						<rect x="-11.6" y="43.6" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -20.7107 50)" width="123.3" height="12.8"/>
						<path d="M21.8,43.6C9.8,43.6,0,33.8,0,21.8S9.8,0,21.8,0s21.8,9.8,21.8,21.8S33.8,43.6,21.8,43.6z M21.8,12.8
								c-4.9,0-9,4-9,9s4,9,9,9s9-4,9-9S26.7,12.8,21.8,12.8z"/>
						<path d="M78.2,100c-12,0-21.8-9.8-21.8-21.8s9.8-21.8,21.8-21.8S100,66.2,100,78.2S90.2,100,78.2,100z M78.2,69.2
								c-4.9,0-9,4-9,9c0,4.9,4,9,9,9c4.9,0,9-4,9-9C87.2,73.3,83.2,69.2,78.2,69.2z"/>
				</svg>
			`
      bannerCTAIcon = `<div class="banner-cta__icon">${svgSale}</div>`
    }
  } else {
    bannerCTAIcon = ''
  }

  if (bannerCTAAddonBGOverlay) {
    bannerCTABGOverlay = `style='background-image:url(${bannerCTAAddonBGImage})'`
  } else {
    bannerCTABGOverlay = ''
  }
}

// Set design for button in detail
function setBannerCTADesign() {
  if (bannerCTAAddonRadius) {
    bannerCTARadius = 'has-border-radius'
  } else {
    bannerCTARadius = ''
  }

  if (bannerCTAAddonBG) {
    bannerCTABG = 'has-bg'
  } else {
    bannerCTABG = ''
  }

  if (bannerCTAAddonBorder) {
    bannerCTABorder = 'has-border'
  } else {
    bannerCTABorder = ''
  }

  if (bannerCTAAddonBGSide) {
    bannerCTABGSide = 'has-side-img'
  } else {
    bannerCTABGSide = ''
  }

  if (bannerCTAAddonBGOverlay) {
    bannerCTABGOverlaySet = 'has-overlay-img'
  } else {
    bannerCTABGOverlaySet = ''
  }
}

// Set text for button in detail
function setBannerCTAText() {
  if (bannerCTATitle) {
    bannerTitle = bannerCTATitle
  } else {
    bannerTitle = ''
  }

  if (bannerCTAText) {
    bannerText = '<div class="banner-cta__text">' + bannerCTAText + '</div>'
  } else {
    bannerText = ''
  }

  if (bannerCTALinkHref) {
    bannerLink = bannerCTALinkHref
  } else {
    bannerLink = ''
  }
}

function removeButton() {
  $('.result-block > div').remove()
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    inputColor.val('#' + inputValue)
    // inputColor.trigger('change')
  })
})
